import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'

const config = {
    apiKey: "AIzaSyA7pzKLni6ILqvDaMHrRHtueOCRC-yHDW8",
    authDomain: "theuniverse-f5c32.firebaseapp.com",
    databaseURL: "https://theuniverse-f5c32.firebaseio.com",
    projectId: "theuniverse-f5c32",
    storageBucket: "theuniverse-f5c32.appspot.com",
    messagingSenderId: "285793919450",
    appId: "1:285793919450:web:85b73b9b40d5d84e"
}

firebase.initializeApp(config)

firebase.firestore().enablePersistence()
.catch(function(err) {
    if (err.code == 'failed-precondition') {
        console.log('Multiple tabs open, persistence can only be enabled in one tab at a a time')
    } else if (err.code == 'unimplemented') {
        console.log('The current browser does not support all of the features required to enable persistence')
    }
})

const firebaseapp = firebase.app()
const db = firebaseapp.firestore()
const storage = firebaseapp.storage()
const auth = firebaseapp.auth()

export { db, storage, auth }